<template>
    <el-card>
        <el-page-header @back="close" content="数据字典编辑"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
                    <el-form-item label="组名" prop="category">
                        <el-input v-model="form.category" maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="字典KEY" prop="name">
                        <el-input v-model="form.name" maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="字典值" prop="value">
                        <el-input v-model="form.value"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="text">
                        <el-input v-model="form.text"></el-input>
                    </el-form-item>
                    <el-form-item label="优先级" prop="priority">
                        <el-input-number v-model="form.priority"></el-input-number>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>

    export default {
        components: {
        },
        props: ["id"],
        data() {
            return {
                form: {
                    roles: [],
                    status: "ENABLE",
                    datasource: {}
                },
                rules: {
                    name: [
                        {required: true, message: '请输入用户名'},
                        {min: 5, max: 20, message: '长度在 5 到 20 个字符'}
                    ],
                    alias: [
                        {required: true},
                        {min: 2, max: 20, message: '长度在20个字符之内'}
                    ],
                    password: [
                        {required: true},
                        {min: 14, max: 20, message: '长度在 14 到 20 个字符'}
                    ],
                    roles: [
                        {required: true, type: "array", min: 1, message: "请选择角色"},
                    ],
                    datasourceId: [
                        {required: true, message: '请选择数据源'},
                    ],
                },
                roles: []
            };
        },
        beforeMount() {
            if (this.id > 0) {
                this.$axios.get("/dict/get/" + this.id).then(response => {
                    let data = response.data;
                    this.form = data;
                });
            }
        },
        methods: {
            submit() {
                let data = this.$utils.clone(this.form);
                let url = this.form.id ? "/dict/edit" : "/dict/save";
                this.$utils.submit(this.$refs.form, url, data, () => {
                    this.$emit("close", true);
                });
            },
            close() {
                this.$emit("close", false);
            },
        },
    }
</script>